<template>
  <span class="d-inline-block text-center border me-2" style="max-height: 3.5rem; width: 3.5rem">
    <img v-if="options.image" :src="data.image" style="max-height: inherit; max-width: inherit" />
  </span>
  {{ value }}
</template>

<script>
export default {
  components: {},
  props: {
    value: { type: String, default: null },
    options: {
      type: Object,
      default: () => ({
        image: false,
        icon: false, // not yet implemented
      }),
    },
    data: {
      type: Object,
      default: () => ({
        image: '/img/dataforge-silver.svg',
        icon: {}, // not yet implemented
      }),
    },
  },
  setup() {
    return {};
  },
};
</script>
